import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import SignupPage from './components/SignupPage';
import Dashboard from './components/layout/Dashboard';
import DashboardAlumni from './alumnicomponents/dashboardalumni';
import ForgetPass from './components/Forgetpass';
import * as P from './pages';
// import * as C from "../componentsM/index";
import RootLayout  from './layout/RootLayout'; // Import your RootLayout
import './global.css'
import Home from './pages/Home';
import PreSchool from './pages/PreSchool';
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('userToken');
  const location = useLocation();
  const isForgetPassword = location.pathname === '/forgetpassword';

  return token || isForgetPassword ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        
        <Route path="/" element={<RootLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/Library" element={<P.Library />} />
          <Route path="/TheArts" element={<P.TheArts />} />
          <Route path="/AwardOfDiploma" element={<P.AwardOfDiploma />} />
          <Route path="/Mathematics" element={<P.Mathematics />} />
          <Route path="/Sciences" element={<P.Sciences />} />
          <Route path="/IndividualsAndSocieties" element={<P.IndividualsAndSocieties />} />
          <Route path="/LanguageAcquisition" element={<P.LanguageAcquisition />} />
          <Route path="/StudiesInLanguage" element={<P.StudiesInLanguage />} />
          <Route path="/CoreProgram" element={<P.CoreProgram />} />
          <Route path="/MYPAssessments" element={<P.MYPAssessments />} />
          <Route path="/NationalRequirements" element={<P.NationalRequirements />} />
          <Route path="/MYP" element={<P.MYP />} />
          <Route path="/hol" element={<P.Holistic />} />
          <Route path="/MYPProjects" element={<P.MYPProjects />} />
          <Route path="/ApproachesToLearn" element={<P.ApproachesToLearn />} />
          <Route path="/GlobalContexts" element={<P.GlobalContexts />} />
          <Route path="/ConceptualLearning" element={<P.ConceptualLearning />} />
          <Route path="/ExtraCircullarProgram" element={<P.ExtraCircullarProgram />} />
          <Route path="/Assessment" element={<P.Assessment />} />
          <Route path="/Curriculum" element={<P.Curriculum />} />
          <Route path="/PrimaryYearsProgram" element={<P.PrimaryYearsProgram />} />
          <Route path="/CulminatingEvents" element={<P.CulminatingEvents />} />
          <Route path="/Action" element={<P.Action />} />
          <Route path="/InternationMindedness" element={<P.InternationMindedness />} />
          <Route path="/gallery" element={<P.Gallery />} />
          <Route path="/testimonials" element={<P.Testimonials />} />
          <Route path="/OurValue" element={<P.OurValue />} />
          <Route path="/TISLanguageProfile" element={<P.TISLanguageProfile />} />
          <Route path="/TISParliament" element={<P.TISParliament />} />
          <Route path="/Admission" element={<P.Admission />} />
          <Route path="/AlumniRegistration" element={<P.AlumniRegistration />} />
          <Route path="/Alumni/*" element={<P.Alumni />} />
          <Route path="/CandidateLogin" element={<P.CandidateLogin />} />
          <Route path="/JobVacancies" element={<P.JobVacancies />} />
          <Route path="/GettingInvolved" element={<P.GettingInvolved />} />
          <Route path="/Giving" element={<P.Giving />} />
          <Route path="/ContactDetails" element={<P.ContactDetails />} />
          <Route path="/AdmissionProcess" element={<P.AdmissionProcess />} />
          <Route path="/AfricaEuropeAsia" element={<P.AfricaEuropeAsia />} />
          <Route path="/applynow" element={<P.ApplyNow />} />
          <Route path="/educational-technology" element={<P.EducationalTechnology />} />
          <Route path="/StudentPersonalDevelopment" element={<P.StudentPersonalDevelopment />} />
          <Route path="/CodeOfConduct" element={<P.CodeOfConduct />} />
          <Route path="/CASProgram" element={<P.CASProgram />} />
          <Route path="/SocietiesAndClub" element={<P.SocietiesAndClub />} />
          <Route path="/Cafeteria" element={<P.Cafeteria />} />
          <Route path="/Counselling" element={<P.Counselling />} />
          <Route path="/CareerAndUniCounseling" element={<P.CareerAndUniCounseling />} />
          <Route path="/IBDiploma" element={<P.IBDiploma />} />
          <Route path="/FeeStructure" element={<P.FeeStructure />} />
          <Route path="/AdmissionRequirements" element={<P.AdmissionRequirements />} />
          <Route path="/MeetTheAdmissionTeam" element={<P.MeetTheAdmissionTeam />} />
          <Route path="/INTERNATIONAL-BACCALAUREATE" element={<P.International />} />
          <Route path="/OurVission" element={<P.OurVission />} />
          <Route path="/PreSchool" element={<PreSchool />} />
          <Route path="/OrganizationalCharts" element={<P.OrganizationalCharts />} />
          <Route path="/Accreditation" element={<P.Accreditation />} />
          <Route path="/Tishistory" element={<P.TisHistory />} />
          <Route path="/StrategicPlan" element={<P.StrategicPlan />} />
          <Route path="/BoardOfGoverners" element={<P.BoardOfGoverners />} />
          <Route path="/ParentCouncil" element={<P.ParentCouncil />} />
          <Route path="/SchoolLeadershipTeam" element={<P.SchoolLeadershipTeam />} />
          <Route path="/HeadsMessage" element={<P.HeadsMessage />} />
          <Route path="/Scholarship" element={<P.Scholarship />} />          
        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgetpassword" element={<ForgetPass />} />
        <Route path="/*" element={
          <PrivateRoute>
            <DashboardAlumni />
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;
